import { type InputProps, InputWrapper } from '../inputWrapper/InputWrapper'
import { createInternalWrapperPropsAndId } from '../utility'
import { RawDoubleInput, type RawDoubleInputProps } from './RawDoubleInput'

export type DoubleInputProps = RawDoubleInputProps & InputProps

export const DoubleInput = ({
  wrapperProps,
  ...fieldProps
}: DoubleInputProps) => {
  const { internalWrapperProps, id } = createInternalWrapperPropsAndId({
    wrapperProps,
    id: fieldProps.id,
  })

  return (
    <InputWrapper {...internalWrapperProps}>
      <RawDoubleInput {...fieldProps} id={id} />
    </InputWrapper>
  )
}
